export const USER_ROLE_UNREGISTERED = "unregistered";
export const USER_ROLE_GUEST = "guest"; // user registered, but account not activated
export const USER_ROLE_REGISTERED = "registered"; // user registered and activated account
export const USER_ROLE_ADMIN = "admin"; // superuser



// WEBPACK FOOTER //
// ./src/constants.js